import React from 'react';
import { memoize } from 'lodash-es';
import loadable from '@loadable/component';
import hoistNonReactStatics from 'hoist-non-react-statics';

import SomethingWentWrongPage from 'ha/pages/SomethingWentWrongPage';

const PageInit = loadable.lib(props =>
  import(`ha/pages/${props.page}/index.ts`),
);

export const createRouteComponent = (store, page) =>
  PageInit.load({ page })
    .then(({ default: init }) => init(store))
    .then(PageComponent => {
      const Component = props => (
        <React.Fragment>
          {/* PageInit rendered to add bundles to initial html */}
          <PageInit page={page} />
          <PageComponent {...props} />
        </React.Fragment>
      );

      // hoist statics to make asyncConnect work
      hoistNonReactStatics(Component, PageComponent);

      return Component;
    })
    .catch(() => SomethingWentWrongPage);

export const getRouteComponents = isServer => {
  // don't memoize on server side to avoid memory leaks
  const createRouteComponentEnhanced = isServer
    ? store => page => createRouteComponent(store, page)
    : memoize(store => memoize(page => createRouteComponent(store, page)));

  return store => page => (nextState, callback) => {
    createRouteComponentEnhanced(store)(page).then(Component =>
      callback(null, Component),
    );
  };
};
